// extracted by mini-css-extract-plugin
export default {"title-container":"InstructionTitle_title-container__EMJXA","title-heading":"InstructionTitle_title-heading__7v1P3","title-subtitle":"InstructionTitle_title-subtitle__vKYCC"};